import React, { useState } from 'react';

function SurveyStepTwentyNine({ formData, onNext }) {
    const [feedbackComfort, setFeedbackComfort] = useState(formData.feedbackComfort || '');
    const [feedbackComments, setFeedbackComments] = useState(formData.feedbackComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!feedbackComfort) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ feedbackComfort, feedbackComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 7: Leadership & Management</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How comfortable do you feel expressing opinions and giving honest feedback to your managers? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`feedback-comfort-${option}`}
                            name="feedbackComfort"
                            value={option}
                            checked={feedbackComfort === option}
                            onChange={() => setFeedbackComfort(option)}
                        />
                        <label htmlFor={`feedback-comfort-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={feedbackComments}
                    onChange={(e) => setFeedbackComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!feedbackComfort}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepTwentyNine;
